
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MessageRevision"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageId"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentRevision"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastEditTime"},"arguments":[],"directives":[]}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageLatestRevision"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useLatestRevision"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageLatestVersion"},"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("@aurora/shared-client/components/messages/MessageId.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@aurora/shared-client/components/messages/MessageVersion/MessageLatestVersion.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./MessageLatestRevision.fragment.graphql").definitions));


    module.exports = doc
  
